import {
    DiJava,
    DiJqueryLogo,
    DiNodejsSmall, DiOpenshift,
    DiReact, DiRuby,
    DiScrum, DiSwift
} from "react-icons/di";
import {
    SiAngular, SiApachemaven, SiJira,
    SiCloudflare, SiVercel, SiNestjs, SiAstro, SiPrisma, SiSpringboot,
    SiCisco,
    SiCsharp,
    SiCss3, SiDynatrace, SiGradle, SiGrafana,
    SiHaskell, SiJunit5, SiMongodb, SiPandas,
    SiPostgresql,
    SiSelenium,
    SiSpring
} from "react-icons/si";
import {
    FaAws,
    FaConfluence,
    FaDocker,
    FaJenkins,
    FaLinux, FaNpm,
    FaPhp,
    FaPython,
    FaRProject,
    FaRust,
    FaVuejs
} from "react-icons/fa";
import {TbBrandJavascript, TbBrandKotlin, TbBrandTypescript, TbFileTypeJsx, TbFileTypeTsx} from "react-icons/tb";
import {BiGitMerge} from "react-icons/bi";
import {FiFigma, FiGitlab, FiGitBranch} from "react-icons/fi";
import {
    AiFillAndroid,
    AiFillApple,
    AiFillGithub,
    AiFillHtml5
} from "react-icons/ai";
import {ImWindows} from "react-icons/im";
import {GrMysql} from "react-icons/gr";
import {BsFiletypeSql, BsFiletypeXml, BsKanbanFill} from "react-icons/bs";
import {IoLogoBitbucket} from "react-icons/io";


export const iconMap = {
    DiJava,
    DiJqueryLogo,
    DiNodejsSmall,
    DiReact,
    DiRuby,
    DiScrum,
    DiSwift,
    SiAngular,
    SiJira,
    SiApachemaven,
    SiCloudflare,
    SiVercel,
    SiNestjs,
    SiAstro,
    SiPrisma,
    SiSpringboot,
    SiCisco,
    SiCsharp,
    SiCss3,
    SiGradle,
    SiHaskell,
    SiJunit5,
    SiMongodb,
    SiPandas,
    SiPostgresql,
    SiSelenium,
    SiSpring,
    FaDocker,
    FaJenkins,
    FaLinux,
    FaPhp,
    FaPython,
    FaRProject,
    FaVuejs,
    TbBrandJavascript,
    TbBrandTypescript,
    BiGitMerge,
    FiFigma,
    FiGitlab,
    FiGitBranch,
    AiFillAndroid,
    AiFillApple,
    AiFillGithub,
    AiFillHtml5,
    ImWindows,
    GrMysql,
    BsFiletypeSql,
    BsFiletypeXml,
    IoLogoBitbucket,
    BsKanbanFill,
    SiGrafana,
    DiOpenshift,
    TbBrandKotlin,
    SiDynatrace,
    FaAws,
    FaRust,
    TbFileTypeJsx,
    TbFileTypeTsx,
    FaConfluence,
    FaNpm
};
